// requestDeduplicator.ts
import sha256 from 'crypto-js/sha256';
import encHex from 'crypto-js/enc-hex';

const requestCache = new Map<string, number>();
const BLOCK_TIME = 2000; // 3 ثانیه

function hashRequest(config: any): string {
  const method = config.method?.toUpperCase() || 'GET';
  const url = config.url || '';
  const data = config.data ? JSON.stringify(config.data) : '';
  const key = `${method}:${url}:${data}`;
  return sha256(key).toString(encHex);
}

export function isDuplicateRequest(config: any): boolean {
  const hash = hashRequest(config);
  const now = Date.now();
  const lastTime = requestCache.get(hash);
  if (!config.url.includes('top-up')) {
    return false
  }
  if (lastTime && now - lastTime < BLOCK_TIME) {
    return true;
  }

  requestCache.set(hash, now);
  return false;
}
